module.exports = __webpack_public_path__ + "static/banking-30d8e5b9f9caf1a2213ede6888299638.webp";